/**
 * Console silencer for kiosk/production usage.
 *
 * By default, we only silence console.warn because third-party libs can spam warnings
 * and kiosk operators shouldn't see DevTools noise.
 *
 * Set:
 * - REACT_APP_SILENCE_CONSOLE=true to silence log/info/debug/trace/table/groups/timers too
 * - REACT_APP_SILENCE_CONSOLE_ERRORS=true to also silence console.error
 */
export function applyConsoleSilencer() {
  if (typeof window === 'undefined' || typeof console === 'undefined') return;

  const env = (typeof process !== 'undefined' && process.env) ? process.env : {};

  const silenceAll =
    env.REACT_APP_SILENCE_CONSOLE === 'true' ||
    env.REACT_APP_ENV === 'e2e' ||
    env.NODE_ENV === 'production';

  const silenceErrors = env.REACT_APP_SILENCE_CONSOLE_ERRORS === 'true';

  const noop = () => {};

  // Always silence warnings (user request).
  try { console.warn = noop; } catch (_) {}

  if (!silenceAll) return;

  try { console.log = noop; } catch (_) {}
  try { console.info = noop; } catch (_) {}
  try { console.debug = noop; } catch (_) {}
  try { console.trace = noop; } catch (_) {}
  try { console.table = noop; } catch (_) {}
  try { console.group = noop; } catch (_) {}
  try { console.groupEnd = noop; } catch (_) {}
  try { console.groupCollapsed = noop; } catch (_) {}
  try { console.time = noop; } catch (_) {}
  try { console.timeEnd = noop; } catch (_) {}
  try { console.count = noop; } catch (_) {}
  try { console.clear = noop; } catch (_) {}

  if (silenceErrors) {
    try { console.error = noop; } catch (_) {}
  }
}

